import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {coral, grey, supportColors} from '../primitives/color';

export class TextInput extends React.Component {
    static propTypes = {
        placeholder: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        type: PropTypes.string,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        hasError: PropTypes.bool,
        className: PropTypes.string,
        fullWidth: PropTypes.bool,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        onChange: () => undefined
    };

    constructor(props) {
        super(props);
        this.state = {
            hasText: !!props.value
        };
    }

    onChange = (e) => {
        if (e.target.value) {
            this.setState({hasText: true});
        }
        else {
            this.setState({hasText: false});
        }

        this.props.onChange(e);
    };

    render() {
        /* eslint-disable no-unused-vars */
        const {onChange, className, ...props} = this.props;
        return (
            <Input
                className={`${className} ${this.props.hasError ? 'error' : ''}`}
                hasText={this.state.hasText}
                onChange={this.onChange} {...props}/>
        );
    }
}


const Input = styled.input`
  &[type="number"],
  &[type="email"],
  &[type="password"],
  &[type="text"] {
      font-family: 'Roboto', sans-serif;
      height: 36px;
      color: ${grey.grey100};
      border: 1px solid ${grey.grey400};
      background-color: #fff;
      font-size: 16px;
      padding-left: 12px;
      padding-right: 12px;
      border-radius: 0;
      box-sizing: border-box;
      width: ${({fullWidth}) => fullWidth ? '100%' : '280px'};

      &::placeholder {
        color: ${grey.grey400};
      }

      &:focus {
         border: 2px solid ${({hasText}) => hasText ? coral.lighter : coral.regular};
         outline: none;
         padding-left: 11px;
         padding-right: 11px;
      }

      &.error {
         border: 2px solid ${supportColors.crimson};
         padding-left: 11px;
         padding-right: 11px;
      }
      
      &:disabled {
        cursor: not-allowed;
        background-color: ${grey.grey900}; 
      }
  } 
  
`;
Input.displayName = 'Input';
